import React from 'react'
import './TeamsPage.css';

const Founders = () => {
  return (
    <div className='founders'>
        <article className = "member">
              
              <div className="photo-image">
                <img src="https://user-images.githubusercontent.com/96824839/171794126-16b6182a-65f3-483b-95f1-04682526a6ca.jpg" alt="" />
                <div className = "hello">
                <span><a href="https://www.facebook.com/profile.php?id=100057206746965" target = "_blank"><i className="fa-brands fa-facebook"></i></a></span>
                <span><a href="mailto:surajgupta.3072@gmail.com" target = "_blank"><i className="fa-solid fa-envelope"></i></a></span>
                <span><a href="#" target = "_blank"><i className="fa-brands fa-instagram-square"></i></a></span>
                <span><a href="https://www.linkedin.com/in/suraj-gupta-457496201/" target = "_blank"><i className="fa-brands fa-linkedin"></i></a></span>
                <span><a href="https://github.com/surajgupta3072/" target = "_blank"><i class="fa-brands fa-github"></i></a></span>
              </div>
              </div>
              <h5><strong>Suraj Gupta</strong></h5>
              
            </article>

          
            <article className = "member">
              
              <div className="photo-image">
                <img src="https://user-images.githubusercontent.com/93533913/190714232-3f1ff3ee-92f4-4d8c-93f9-79426951a130.png" alt="" />
                <div className = "hello">
                <span><a href="https://www.facebook.com/bhushan.nakade.984" target = "_blank"><i className="fa-brands fa-facebook"></i></a></span>
                <span><a href="mailto:bhushantny1@gmail.com" target = "_blank"><i className="fa-solid fa-envelope"></i></a></span>
                <span><a href="https://www.instagram.com/_.bhushan._/" target = "_blank"><i className="fa-brands fa-instagram-square"></i></a></span>
                <span><a href="https://www.linkedin.com/in/bhushan-nakade-141971209/" target = "_blank"><i className="fa-brands fa-linkedin"></i></a></span>
                <span><a href="https://github.com/imshresth0810" target = "_blank"><i class="fa-brands fa-github"></i></a></span>
              </div>
              </div>
              <h5><strong>Bhushan Nakade</strong></h5>
              
            </article>
                
               
              
    
            
    </div>
  )
}

export default Founders
